import { AfterViewInit, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { cloneDeep } from 'lodash';

import { AutoNumericDirective } from '../../../directives/auto-numeric.directive';
import { BaseUI } from '../../base.ui';
import { FundTransfer } from '../../../domain/data';
import { FundTransferInterface, TransferInterface } from '../../../../core';
import { ParentEvents } from '../../../utils/parent-events.service';
import { Contract } from '../../../domain/data';
import { MatDialog } from '@angular/material/dialog';
import { GetContractUseCase } from '../../../../core';
import { ErrorDialog } from '../../dialog/error/error.dialog';


@Component({
    selector: 'thr-transfer-form',
    templateUrl: './transfer-form.component.html',
    styleUrls: ['./transfer-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class TransferFormComponent extends BaseUI implements AfterViewInit, OnChanges, OnDestroy, OnInit {
    public initialAmount = 0;

    public adding = false;
    public currentFundTransfer: FundTransferInterface;

    public contract: Contract;
    public allowTransfers: boolean;


    @Input()
    transfer: TransferInterface;


    @ViewChild('transferBankAmountDirective')
    transferBankAmountDirective: AutoNumericDirective;

    constructor(
        parentEvents: ParentEvents,
        private getContractUseCase: GetContractUseCase,
        private dialog: MatDialog,
) {
        super(parentEvents);
    }

    private getContract() {
        this.getContractUseCase.bind().subscribe((transaction) => {
            if (transaction.isSuccess) {
                this.contract = transaction.data as Contract;
                this.allowTransfers = this.contract.allowTransfers;
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog);
            }
        });
    }

    ngOnInit() {
        this.initialAmount = this.transfer?.amount || 0;
        this.getContract();
    }
    ngOnChanges(changes: SimpleChanges): void {
        if ('transfer' in changes && !!this.transfer && this.transfer.fundTransfers.length === 0) {
            this.onAdd();
        }
    }

    onAdd(): void {
        this.adding = true;
        this.currentFundTransfer = new FundTransfer();
    }

    onEdit(fundTransfer: FundTransferInterface): void {
        this.adding = true;
        this.currentFundTransfer = cloneDeep(fundTransfer);
    }

    onRemove(fundTransfer: FundTransferInterface): void {
        this.transfer.removeTransfer(fundTransfer);

        if (this.transfer.fundTransfers.length === 0) {
            this.onAdd();
        }

        this.parentEvents.resize();
    }

    onCancel(): void {
        this.adding = false;
        this.currentFundTransfer = undefined;

        if (this.transfer.fundTransfers.length === 0) {
            this.onAdd();
        }
    }

    onAmountChange() {
        if (this.transferBankAmountDirective) {
            this.transfer.amount = this.transferBankAmountDirective.value;
        }
    }

    onSubmitTransfer(): void {
        this.transfer.addTransfer(this.currentFundTransfer);
        // this.onCancel();
    }
}
